import { useEffect, useRef, useState } from "react";
import { SFX, unlockAudio, resumeAudio } from "@/lib/sound";

const KEY = "holdem-sound";

function sfxFor(e) {
  if (e.kind === "win") return "win";
  if (e.kind === "street" || e.kind === "hand") return "deal";
  if (e.kind !== "action") return null;
  if (/all-in/.test(e.text)) return "allIn";
  if (/ checks?$/.test(e.text)) return "knock";
  if (/ folds?$/.test(e.text)) return "fold";
  if (/ (posts?|calls?|bets?|raises? to) /.test(e.text)) return "chips";
  return null;
}

export function useGameSounds(game) {
  const [enabled, setEnabled] = useState(() => localStorage.getItem(KEY) !== "off");
  const lastLog = useRef(null);
  const wasMyTurn = useRef(false);

  const toggle = () => {
    const next = !enabled;
    localStorage.setItem(KEY, next ? "on" : "off");
    if (next) { unlockAudio(); try { SFX.chips(); } catch (e) { /* audio unsupported */ } }
    setEnabled(next);
  };

  useEffect(() => {
    const onVisible = () => { if (document.visibilityState === "visible") resumeAudio(); };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    return () => { document.removeEventListener("visibilitychange", onVisible); window.removeEventListener("focus", onVisible); };
  }, []);

  useEffect(() => {
    if (!game) { lastLog.current = null; return; }
    const seq = game.logSeq;
    const prev = lastLog.current ?? 0;
    lastLog.current = seq;
    const myTurn = game.phase === "betting" && game.toAct === 0;
    const turnStarted = myTurn && !wasMyTurn.current;
    wasMyTurn.current = myTurn;
    if (!enabled) return;
    const fresh = game.log.filter((e) => e.id > prev);
    const sounds = [...new Set(fresh.map(sfxFor).filter(Boolean))];
    const pick = ["win", "allIn", "chips", "knock", "fold", "deal"].find((s) => sounds.includes(s));
    try {
      if (pick) SFX[pick]();
      if (turnStarted) setTimeout(() => SFX.turn(), pick ? 250 : 0);
    } catch (e) { /* audio unsupported */ }
  }, [game, enabled]);

  return { enabled, toggle };
}
